import { Component } from '@angular/core';

@Component({
  selector: 'app-card-header-loader',
  styleUrls: ['./card-header-loader.component.scss'],
  template: `
    <app-card [cardClasses]="'mb-8'">
      <ng-container cardBody>
        <app-skeleton-text [height]="25" [width]="230"></app-skeleton-text>
        <app-skeleton-text [height]="20" [width]="350"></app-skeleton-text>
        <div class="row w-100">
          <div class="col-12 col-md-3 mt-3">
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
          </div>
          <div class="col-12 col-md-3 mt-3">
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
          </div>
          <div class="col-12 col-md-3 mt-3">
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
          </div>
          <div class="col-12 col-md-3 mt-3">
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
            <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
          </div>
        </div>
      </ng-container>
    </app-card>
  `,
})
export class CardHeaderLoaderComponent {}
